export default __webpack_public_path__ + "static/media/img-card-04.bf547ff0.jpg";